<template>
  <div>
    <wc-dialog :showDialog='showDialog' title='Project Details' :icon='$store.state.icons.modules.projects.icon'
      :loading='isLoading' width='1200' hideCancel saveText='Close' @save="close">
      <template v-slot:toolbarButtons>
        <v-btn small color='primary' elevation='0' @click='close'>Close</v-btn>
      </template>
      <div v-if='projectCopy'>
        <v-row dense>
          <v-col cols='12' md='6'>
            <span class='headline'>{{ project.name }}</span>
          </v-col>

          <v-col cols='12' md='6' class='text-right'>
          </v-col>

          <v-col cols='12'>
            <wc-data-box mini title='Contacts' :titleIcon='$store.state.icons.modules.clients.icon'
              :titleIconColor='$store.state.icons.modules.clients.color'>
              <v-simple-table dense v-if='projectCopy'>
                <tbody>
                  <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Home</th>
                    <th>Cell</th>
                    <th>Work</th>
                  </tr>
                  <tr v-if='projectCopy.owner_obj'>
                    <td class='grey--text'>Owner</td>
                    <td>{{ projectCopy.owner_obj.name_display }}</td>
                    <td>{{ projectCopy.owner_obj.email }}</td>
                    <td>{{ projectCopy.owner_obj.home_phone }}</td>
                    <td>{{ projectCopy.owner_obj.cell_phone }}</td>
                    <td>{{ projectCopy.owner_obj.work_phone }}
                      <span v-if='projectCopy.owner_obj.work_phone_extension'>{{ " ext. " +
                        projectCopy.owner_obj.work_phone_extension }}</span>
                    </td>
                  </tr>
                  <tr v-if='projectCopy.bill_to_obj'>
                    <td class='grey--text'>Billing</td>
                    <td>{{ projectCopy.bill_to_obj.name_display }}</td>
                    <td>{{ projectCopy.bill_to_obj.email }}</td>
                    <td>{{ projectCopy.bill_to_obj.home_phone }}</td>
                    <td>{{ projectCopy.bill_to_obj.cell_phone }}</td>
                    <td>{{ projectCopy.bill_to_obj.work_phone }}
                      <span v-if='projectCopy.bill_to_obj.work_phone_extension'>{{ " ext. " +
                        projectCopy.bill_to_obj.work_phone_extension }}</span>
                    </td>
                  </tr>
                  <tr v-if='projectCopy.site_contact_obj'>
                    <td class='grey--text'>Site Contact</td>
                    <td>{{ projectCopy.site_contact_obj.name_display }}</td>
                    <td>{{ projectCopy.site_contact_obj.email }}</td>
                    <td>{{ projectCopy.site_contact_obj.home_phone }}</td>
                    <td>{{ projectCopy.site_contact_obj.cell_phone }}</td>
                    <td>{{ projectCopy.site_contact_obj.work_phone }}
                      <span v-if='projectCopy.site_contact_obj.work_phone_extension'>{{ " ext. " +
                        projectCopy.site_contact_obj.work_phone_extension }}</span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </wc-data-box>
          </v-col>
          <v-col cols='12' md='4'>
            <lawn-details v-if='projectCopy && projectCopy.division_obj.division == "Lawn"' :project='projectCopy'
              @update='update'></lawn-details>
            <snow-details v-if='projectCopy && projectCopy.division_obj.division == "Snow"' :project='projectCopy'
              @update='update'></snow-details>
          </v-col>
          <v-col cols='12' md='4'>
            <crew-visits v-if='projectCopy' :project='projectCopy' :max-height='303'></crew-visits>
          </v-col>
          <v-col cols='12' md='4'>
            <wc-data-box mini title='Scheduling Considerations' titleIcon='mdi-calendar-cursor' titleIconColor='primary'
              v-if='projectCopy && projectCopy.division_obj.division == "Lawn"'>
              <wc-two-column-table :items='lawnData'></wc-two-column-table>
              <v-card-text v-html='projectCopy.project_detail.scheduling_considerations'></v-card-text>
            </wc-data-box>
            <lawn-care-instructions v-if='projectCopy && projectCopy.division_obj.division == "Lawn"' class='mt-6'
              :project='projectCopy' @update='update'></lawn-care-instructions>

            <driveway-rating v-if='projectCopy && projectCopy.division_obj.division == "Snow"' :project='projectCopy'
              :showEdit='false' @update='update'></driveway-rating>
            <field-instructions v-if='projectCopy && projectCopy.division_obj.division == "Snow"' class='mt-11'
              :project='projectCopy' @update='update'></field-instructions>
          </v-col>
        </v-row>
      </div>
      <template v-slot:dialog-actions v-if='projectCopy'>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 15px;">
          <v-btn outlined small text
            :to="{ name: projectCopy.division_obj.division + 'Overview', params: { id: project.id } }">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Project
          </v-btn>
          <v-btn small outlined text color='info' @click='loadPrev'>
            Prev
            <v-icon right small color="info">mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn small outlined text color='info' @click='loadNext'>
            Next
            <v-icon right small color="info">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import projectsAPI from '@/modules/projects/api/projects';
import lawnAPI from '@/modules/lawn/api/';
import snowAPI from '@/modules/snow/api/';
import LawnDetails from '@/modules/lawn/components/LawnDetails';
import SnowDetails from '@/modules/snow/components/Details';
import FieldInstructions from '@/modules/projects/components/FieldInstructions';
import DrivewayRating from '@/modules/snow/components/DrivewayRating';
import CrewVisits from '@/modules/wos/views/woDetail/CrewVisits';
import LawnCareInstructions from '@/modules/lawn/components/LawnCareInstructions';

export default {
  name: 'project-quick-view',
  props: {
    project: {
      required: true
    },
    showDialog: {
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      projectCopy: null,
    }
  },
  watch: {
    project: function (old_project, project) {
      console.log(old_project.id, project.id);
      this.getData();
    },
  },
  computed: {
    lawnData() {
      return [{ text: 'Scheduling Considerations:', value: "" }]
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.projectCopy = await projectsAPI.getProject(this.project.id);
      this.isLoading = false;
    },
    close() {
      this.$emit('close')
    },
    async update(project) {
      this.isLoading = true
      if (project.division_obj.division == "Lawn") {
        await lawnAPI.updateLawnProject(project.project_detail)
      } else if (project.division_obj.division == "Snow") {
        await snowAPI.updateSnowProject(project.project_detail)
      }
      this.projectCopy = await projectsAPI.updateProject(project)
      this.isLoading = false
    },
    loadNext() {
      this.$emit("loadNext");
    },
    loadPrev() {
      this.$emit("loadPrev");
    }
  },
  components: {
    'lawn-details': LawnDetails,
    'crew-visits': CrewVisits,
    'lawn-care-instructions': LawnCareInstructions,
    'field-instructions': FieldInstructions,
    'snow-details': SnowDetails,
    'driveway-rating': DrivewayRating
  }
}
</script>
